/* global CLOSURE_BUILD_VERSION */

const prefix = window.SAMAP_PREFIX || window.location.origin;

function writeScript(src) {
  // CLOSURE_BUILD_VERSION will be replaced by webpack.DefinePlugin
  document.write('<script src="' + prefix + src + '?version=' + CLOSURE_BUILD_VERSION + '"></script>');
}

function populateTemplateCache(module, context, pathFn) {
  module.run(['$templateCache', function($templateCache) {
    context.keys().forEach(function(templatePath) {
      const key = pathFn(templatePath);
      const content = context(templatePath);
      $templateCache.put(key, content);
    });
  }]);
}

module.exports = function(appUrl, mainModule, mainController, htmlContext, cb) {
  const search = window.location.search;
  const isWebpackDev = window.location.host.match(/:8180/);
  const isDebug = isWebpackDev || search.indexOf('?debug') !== -1;

  if (isDebug) {
    writeScript('/js/goog/library/base.js');
    writeScript('/build/deps.js');
    document.write('' +
      '<script>' +
      '  goog.define("goog.DEBUG", true);' +
      '  goog.define("goog.SEAL_MODULE_EXPORTS", false);' +
      '  goog.require("' + mainController + '");' +
      '</script>');
  } else {
    writeScript(appUrl);
  }

  window.suissealpineInit = function() {
    function getUrl_(port, pathSuffix) {
      const isDev = window.location.host.match(/:8.80/);
      if (isDev) {
        return prefix.replace(/:8.80/, ':' + port) + pathSuffix;
      } else {
        return prefix + pathSuffix;
      }
    }

    const module = angular.module(mainModule);

    // Set URLs
    module.constant('photoUrl', getUrl_(8189, '/photo/'));
    module.constant('apiUrl', getUrl_(8480, '/api/1'));
    module.constant('printUrl', getUrl_(8680, ''));

    // Load templates
    populateTemplateCache(module, htmlContext, function(path) {
      return mainModule + path.substr(1);
    });

    // Load png icons
    const pngIconContext = require.context('../static/img/icons', true, /\.png$/);
    populateTemplateCache(module, pngIconContext, function(path) {
      return '/img/icons' + path.substr(1);
    });

    // Load svg icons
    const svgIconContext = require.context('../static/img/icons/poi_routes', true, /\.svg$/);
    populateTemplateCache(module, svgIconContext, function(path) {
      return '/img/icons/poi_routes' + path.substr(1);
    });

    // Load placemark svg icons
    const iconContext = require.context('../static/samap/img/placemarks', false, /\.svg/);
    populateTemplateCache(module, iconContext, function(path) {
      return '/samap/img/placemarks' + path.substr(1);
    });

    if (cb) {
      cb(module);
    }
  };

  document.write('' +
    '<script>' +
    '  window.suissealpineInit();' +
    '</script>');
};



//////////////////
// WEBPACK FOOTER
// /app/suissealpine/webpack/loadapp.common.js
// module id = 137
// module chunks = 0 2